import Splide from '@splidejs/splide';

document.addEventListener('DOMContentLoaded', function () {
    const main = new Splide('.regions-slider', {
        // fixedWidth: 314.5,
        autoWidth: true,
        gap: 16,
        rewind: true,
        pagination: false,
        arrows: false,
        drag: false,
        breakpoints: {
            1360: {
                drag: true,
            },
        },
    });

    const thumbnails = new Splide('.regions-slider-thumbnails', {
        gap: 10,
        rewind: true,
        pagination: false,
        autoWidth: true,
        drag: false,
        arrows: false,
        isNavigation: true,
    });

    main.sync(thumbnails);
    main.mount();
    thumbnails.mount();

});